/* Matia — shared scroll-snap carousel (arrows + optional dot sync).
 *
 * Markup contract:
 *   root:   [data-matia-carousel]   attribute value = card CSS selector
 *   track:  [data-carousel-track]   the scroll-snap flex container
 *   arrows: [data-carousel-prev] / [data-carousel-next]
 *   dots:   [data-carousel-dots] > span  (optional — active dot follows scroll)
 *
 * Loaded once from layout/theme.liquid. Multi-instance, idempotent, and
 * re-initializes on shopify:section:load (theme editor).
 */
(function () {
  'use strict';

  function init(root) {
    if (root.matiaCarouselReady) return;
    root.matiaCarouselReady = true;

    var cardSel = root.getAttribute('data-matia-carousel');
    var track = root.querySelector('[data-carousel-track]');
    if (!track || !cardSel) return;

    /* One card plus the track's CSS gap. */
    var step = function () {
      var card = track.querySelector(cardSel);
      if (!card) return track.clientWidth;
      return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    };

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var dots = root.querySelectorAll('[data-carousel-dots] span');
    if (dots.length) {
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
        });
      });
    }
  }

  function initAll(scope) {
    var host = scope || document;
    if (host.matches && host.matches('[data-matia-carousel]')) init(host);
    var nodes = host.querySelectorAll('[data-matia-carousel]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
